import React from 'react';
import {
  FaFacebookSquare,
  FaInstagram,
  FaTwitterSquare,
  FaYoutube,
  FaEnvelope,
  FaPhoneAlt
} from 'react-icons/fa';
import logo from "../assets/logo1.jpg"

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className='bg-slate-900 text-gray-300 w-full pt-16 pb-8 px-6 md:px-24'>
      <div className='max-w-[1240px] mx-auto'>
        <div className='flex flex-col items-center text-center '>
          
          {/* Logo con borde sutil */}
          <div className='mb-6 p-1 bg-white rounded-full'>
            <img className="w-20 h-20 rounded-full object-cover" src={logo} alt="Logo" />
          </div>

          {/* Eslogan / Llamado a la acción */}
          <h2 className='text-white text-xl font-semibold mb-2'>Fundadocente JDD</h2>
          <p className='max-w-md text-gray-400 mb-8 font-light'>
            Transformando realidades a través de la labor pedagógica. Contáctanos y sé parte del cambio.
          </p>

          {/* Redes Sociales - Minimalistas */}
          <div className='flex justify-center gap-8 mb-10'>
            <a target="_blank" rel="noreferrer" href="https://www.facebook.com/profile.php?id=61553758356775" className='hover:text-blue-500 transition-colors duration-300'>
              <FaFacebookSquare size={26} />
            </a>
            <a target="_blank" rel="noreferrer" href="https://www.instagram.com/fundadocentejdd/" className='hover:text-pink-500 transition-colors duration-300'>
              <FaInstagram size={26} />
            </a>         
            <a target="_blank" rel="noreferrer" href="https://twitter.com/fundaDocenteJDD" className='hover:text-sky-400 transition-colors duration-300'>
              <FaTwitterSquare size={26} />
            </a>      
            <a target="_blank" rel="noreferrer" href="https://www.youtube.com/channel/UCv2MOMGmnU6RkHX9VOrxx0g" className='hover:text-red-600 transition-colors duration-300'>
              <FaYoutube size={26} />
            </a>
          </div>

          {/* Información de Contacto */}
          <div className='flex flex-col md:flex-row gap-6 md:gap-12 text-sm font-medium border-t border-gray-800 py-6 w-full justify-center'>
            <a href="tel:+573007531988" className='flex items-center justify-center gap-2 hover:text-white transition-colors'>
              <FaPhoneAlt className='text-blue-500' /> +57 300 753 19 88
            </a>
            <a href="mailto:fundadocentejdd@gmail.com" className='flex items-center justify-center gap-2 hover:text-white transition-colors'>
              <FaEnvelope className='text-blue-500' /> fundadocentejdd@gmail.com
            </a>
          </div>
        </div>

        {/* Barra Inferior de Copyright */}
        <div className=' pt-8 border-t border-gray-800 text-center text-xs text-gray-500 uppercase tracking-widest'>
          <p>© {currentYear} Fundadocente JDD — Barranquilla, Atlántico, Colombia.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;